export default "__VITE_ASSET__BtdJVOTN__"